import React, { useState, useEffect } from 'react';
import * as core from 'cw-ui-core';
import Routes from 'src/services/Routes';
import UserAccountContainer from './UserAccountContainer';
import AccessDeniedPage from 'src/components/AccessDeniedPage/AccessDeniedPage';
import LoadingComponent from 'src/components/Loading/LoadingComponent';
import { getUserAppRoles } from 'src/services/UserService';
import { BrowserRouter as Router } from 'react-router-dom';
import NeonThemeProvider from 'src/components/Theme/NeonThemeProvider';
import './App.scss';

const APP_STATE = {
    LOADING: 'LOADING',
    ACCESS_DENIED: 'ACCESS_DENIED',
    READY: 'READY',
};

let routes = Object.values(Routes);

const App = props => {
    const [appState, setAppState] = useState(APP_STATE.LOADING);
    const [hasAccessToCreateSSOAccount, setHasAccessToCreateSSOAccount] = useState(false);

    const { onWillMount } = props;
    useEffect(() => {
        onWillMount(isAuthorized => {
            setAppState(isAuthorized ? APP_STATE.READY : APP_STATE.ACCESS_DENIED);
        });
    }, [onWillMount]);

    useEffect(() => {
        const appRoles = getUserAppRoles();
        const hasAccessToCreateSSOAccount = appRoles?.some(item => item.appRoleId === 'SSO Account Creator');
        setHasAccessToCreateSSOAccount(hasAccessToCreateSSOAccount);
    }, []);

    if (appState === APP_STATE.LOADING) {
        return (
            <NeonThemeProvider>
                <LoadingComponent />
            </NeonThemeProvider>
        );
    }

    if (appState === APP_STATE.ACCESS_DENIED) {
        return (
            <NeonThemeProvider>
                <AccessDeniedPage />
            </NeonThemeProvider>
        );
    }

    if (!hasAccessToCreateSSOAccount) {
        routes = routes.filter(route => route.id !== 'ssoaccount');
    }

    return (
        <NeonThemeProvider>
            <Router>
                <core.NavigationAppContainer
                    routes={routes}
                    onNavigation={props.onNavigation}
                    menu={
                        <core.NavigationMenu
                            routes={routes}
                            logo={core.IconPath.get('Connectwise-icon-LightBlue')}
                            //logoIsInlineSVG={true}
                            footer={<UserAccountContainer />}
                            onMenuItemClick={props.onMenuItemClick}
                        />
                    }
                />
            </Router>
        </NeonThemeProvider>
    );
};

export default App;
